/**
 * BPM / Workflow: só o que RODA — fluxogramas e fluxos em andamento.
 * Cadastros (etapas, tipos de atividade, checklists) e automações/IA ficam em Configurações.
 */
import { useEffect } from "react";
import { navigate, useSearch, useTitle } from "@/lib/router";
import { useLookups } from "@/lib/catalog";
import { Card, PageHeader, Tabs } from "@/ui/kit";
import { WorkflowSettings } from "./SettingsWorkflows";
import { FlowDefinitions } from "./FlowEditor";
import { FlowsInProgress } from "@/ui/bpm";

type Tab = "fluxogramas" | "andamento" | "fluxos";
/** Abas que mudaram para Configurações (links antigos continuam funcionando). */
const MOVED: Record<string, string> = { checklists: "checklists", automacoes: "automacoes", etapas: "etapas", tipos: "tipos", ia: "ia" };

function GoTo({ to }: { to: string }): null { useEffect(() => navigate(to, { replace: true }), [to]); return null; }

export function WorkflowPage(): JSX.Element {
  useTitle("BPM / Workflow");
  const [search, set] = useSearch();
  const { can } = useLookups();
  const raw = search.get("aba") ?? "";
  if (MOVED[raw] && can("config.gerenciar")) return <GoTo to={`/configuracoes?aba=${MOVED[raw]}`} />;
  const tab: Tab = raw === "andamento" || raw === "fluxos" ? raw : "fluxogramas";
  if (!can("config.gerenciar")) {
    return (
      <div className="stack gap-16">
        <PageHeader title="BPM / Workflow" subtitle="Fluxos em que você participa" />
        <Card title="Fluxos em andamento"><FlowsInProgress mine /></Card>
        <Card><div className="muted small">Somente o administrador desenha fluxos e automações. Você inicia um fluxo na aba “Fluxos” do processo ou do caso, ou na análise da intimação.</div></Card>
      </div>
    );
  }
  return (
    <div className="stack gap-16">
      <PageHeader title="BPM / Workflow" subtitle="Fluxogramas e fluxos em andamento. Etapas, tipos de atividade, checklists e automações ficam em Configurações." />
      <Tabs<Tab> value={tab} onChange={(t) => set({ aba: t, fluxo: null })} tabs={[
        { key: "fluxogramas", label: "Fluxogramas" },
        { key: "andamento", label: "Em andamento" },
        { key: "fluxos", label: "Listas antigas", hidden: tab !== "fluxos" },
      ]} />
      {tab === "fluxogramas" && <FlowDefinitions />}
      {tab === "andamento" && <Card title="Fluxos em andamento"><FlowsInProgress /></Card>}
      {tab === "fluxos" && <div className="stack gap-16"><Card><div className="muted small">Formato antigo (lista de atividades). Os que existiam foram convertidos em fluxogramas e desligados aqui; prefira os Fluxogramas.</div></Card><WorkflowSettings /></div>}
    </div>
  );
}
